import { HotmartRum } from "@commons/observability"

class OtpError extends Error {
    constructor(message?: string) {
        super(message)
        this.name = 'OtpError'
        this.captureError()
    }

    private captureError() {
        HotmartRum.captureException(this)
    }
}

function setMode(mode: string) {
    const otpCodeElement = document.getElementById('otp-code')
    const otpRecoveryElement = document.getElementById('otp-recovery')

    if(!otpCodeElement) throw new OtpError('OTP element not found')
    if(!otpRecoveryElement) throw new OtpError('Recovery element not found')

    localStorage.setItem('recoveryMode', (mode === 'recovery').toString())

    otpCodeElement.classList.toggle('hidden')
    otpRecoveryElement.classList.toggle('hidden')

    toggleTokenInput()
}

function handleRecoveryInput() {
    const recoveryInput = document.getElementById('recovery-token') as HTMLInputElement

    if(!recoveryInput) throw new OtpError('Recovery input not found')

    recoveryInput.oninput = () => {
        const submitButton = document.getElementById('submit-recovery-button') as HTMLInputElement
        submitButton.disabled = recoveryInput.value.length < 6
    }
}

function clearToastMessage() {
    const errorMsg = document.getElementById('msg');
    
    if (!errorMsg) throw new OtpError('Error message not found')

    errorMsg.style.display = 'none';
}

function toggleTokenInput() {
    const otpInput = globalThis.codeInput.hiddenInput
    const recoveryInput = document.getElementById('recovery-token') as HTMLInputElement
    const isRecovery = isRecoveryMode()

    if(!otpInput) throw new OtpError('OTP input not found')
    if(!recoveryInput) throw new OtpError('Recovery input not found')

    globalThis.codeInput.setValue('')
    recoveryInput.value = ''

    otpInput.setAttribute('name', isRecovery ? '' : 'token')
    recoveryInput.setAttribute('name', isRecovery ? 'token' : '')
    
}

function renderRecoveryMode() {
    setMode('recovery')

    handleRecoveryInput()
}

function renderOtpMode() {
    setMode('otp')
}

function isRecoveryMode() {
    return localStorage.getItem('recoveryMode') === 'true'
}

function handleCancelButton() {
    try {
        clearToastMessage()
        isRecoveryMode() ? renderOtpMode() : (window.location.href = '/login' + window.location.search)
    } catch (error) {
        console.error(error)
    }
}

function handleRecoveryButton() {
    try {
        clearToastMessage()
        renderRecoveryMode()
    } catch (error) {
        console.error(error)
    }
}

function isOtpScreen() {
    return !!document.getElementById('otp-code')
}

export function handleOtpMode() {
    if(!isOtpScreen()) return

    isRecoveryMode() ?  renderRecoveryMode() : localStorage.removeItem('recoveryMode')

    const cancelButton = document.getElementById('cancel')
    const recoveryCodeButton = document.getElementById('recovery-code-button')

    if(!cancelButton) throw new OtpError('Cancel button not found')
    if(!recoveryCodeButton) throw new OtpError('Recovery code button not found')
    
    recoveryCodeButton.addEventListener('click', handleRecoveryButton)

    if(cancelButton) {
        cancelButton.onclick = handleCancelButton
    }
}
